<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="$t('initialization.ireferral.eRefe')"            
            v-bind:titleRef="'titleElementReferral'">
        </MdTitleRegInfo>

        <p class="iSetupLabel">
            <i class="ikon med-help"></i>
            {{$t('initialization.ireferral.rProvRef')}}
        </p>

         <div class="row">
            <div class="col-12">              
                <div class="row">
                    <div class="col-sm-12 col-md-3">                      
                        <MdButton
                            v-bind:Label="$t('InitialConf.Addreferral')" 
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddReferral"
                            v-bind:Name="'btn_add_iuser'">
                        </MdButton>
                    </div>

                    <div v-bind:class="'col-sm-12 col-md-9 mb-4'">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"
                                    @keyup.enter="searchListing"
                                >
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="searchListing">
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

       <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>


        <MdTable 
            v-bind:fields="fields"
            v-bind:items="items"
            v-bind:totalRows="totalRows"              
            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
            v-bind:currentPage="currentPage"
            v-bind:perPage="perPage"              
            v-bind:pageOptions="pageOptions"
            :editIconEvent="EditReferral"           
            v-bind:VisibleEditIcon="true"  
            :deleteIconEvent="RemoveReferral"
            v-bind:VisibleDeleteIcon="true"             
            :onRowSelected="onRowSelected"        
            :pageChanged="pageChanged"
            :perPageFunction="PerPageFunction">                
        </MdTable>

     

        <div class="space-actions"></div>
        <div class="page-actions">

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'◄'"           
            v-bind:Name="'btnReferralBack'"
            v-on:click="Back"
            v-bind:ClassProp="'mx-2'"/>

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'►'"
            v-on:click="Next"
            v-bind:Name="'btnreferralsNext'"
            v-bind:ClassProp="'mx-2'"/>  

       <!-- <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="$t('Shared.Save')"
            v-bind:Name="'btnReferral'"
            v-bind:ClassProp="'mx-2 btn-login'"/>-->
        </div>

      



    </div>
   

</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
//import ReferralService from '@/services/referral.service'
//import GlobalService from '@/services/global.service'
//import Utils from "@/common/utils";
import ISetupService from '@/services/isetup.service.js'

export default {
    name: 'IniReferral',
    mixins: [ShowMessage, DBFunctions],
  data(){
    return{
        parameter:{
            SearchCriteria:"",
            PageNumber : 0,
            PageSize:0,
        },
        Header:{},
        ShowMessageIsEmpty:false,
         fields:[
            { key: 'displayName', sortable: true, label: this.$t('Shared.Name'), class: 'text-rigth' },     
            { key: 'recId', sortable: true, label: 'recId', class: 'text-rigth hidden' },         
            { key: 'contact', sortable: true, label: this.$tc('Contact.Contact'), class: 'text-rigth' }, 
            { key: 'type', sortable: true, label: this.$t('initialization.ireferral.tRef'), class: 'text-rigth' }, 
            { key: 'phone', sortable: true, label: this.$t('Shared.Phone'), class: 'text-rigth' }, 
            { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone'), class: 'text-rigth' },
            { key: 'email', sortable: true, label: this.$t('Shared.Email'), class: 'text-rigth' },
            { key: 'fax', sortable: true, label: this.$t('Patient.LegalFax'), class: 'text-rigth' },
            { key: 'address1', sortable: true, label: this.$t('Shared.Address1'), class: 'text-rigth' },
            { key: 'address2', sortable: true, label: this.$t('Shared.Address2'), class: 'text-rigth' },
            { key: 'city', sortable: true, label: this.$t('Shared.City'), class: 'text-rigth' },
            { key: 'zip', sortable: true, label: this.$t('Shared.Zip'), class: 'text-rigth' },
            { key: 'state', sortable: true, label: this.$t('Shared.State'), class: 'text-rigth' }, 
            { key: 'country', sortable: true, label: this.$t('Shared.Country'), class: 'text-rigth' },                         
        ],
        items:[],
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
    }
  },
  methods:{
    EditReferral(row){
        this.$router.push({ name:'ireferraldetail',params: { id: row.recId}});
    },
    RemoveReferral(row){
         this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$t('InitialConf.DeleteReferral'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
          id:'modal_delete_setupReferral'
				})
        .then(value => {
          if(value){
            ISetupService.DeleteReferral(row.recId)
            .then(() => {
                const index = this.items.findIndex(item => item.recId  === row.recId) // find the post index 
                if (~index) {// if the post exists in array 
                  this.items.splice(index, 1) //delete the post and refresh view
                  this.SearchReferral(); //refresh listing
                }
            })
            .catch((error) => {
                this.showResponseErrorMessage(error);
            });
          }
        })
    },
    onRowSelected(){

    },
    PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.SearchReferral();   
    },

    pageChanged(page){
        this.currentPage = page;    
        this.SearchReferral();   
    },
    Next(){
       // this.$router.push({ name:'iprograms'});
    },

    Back(){
       // this.$router.push({ name:'iusers'}); 
    },

    AddReferral(){
        this.$router.push({ name:'ireferraladd'});
    },
    searchListing(){
        this.currentPage = 1;
        this.SearchReferral();
    },

    SearchReferral(){
        this.parameter.PageNumber = this.currentPage;           
        this.parameter.PageSize = this.perPage;       
         ISetupService.getAllReferral(this.parameter)
            .then((response) => {      
               if (response.status == '200' && response.data) {              
                    this.items = response.data;
                    let headerString = response.headers["x-pagination"];
                    this.Header = JSON.parse(headerString);
                    this.totalRows = this.Header.TotalCount;
                  if(this.items.length === 0){
                    this.ShowMessageIsEmpty = true;
                  }
               }  
         })
         .catch(error => {
           this.showResponseErrorMessage(error);
         });    
    }
  },
  mounted(){
    this.SearchReferral();
  }   
};
</script>


